export const CAPACITY = {
  label: "Capacité d'emprunt",
  suffix: '€',
  tooltip: 'Le montant que vous pouvez emprunter pour financer votre achat.',
}

export const CREDIT_COST = {
  label: 'Coût du crédit',
  suffix: '€',
  tooltip: 'Le montant total des intérêts à payer sur la durée de votre crédit.',
}

export const PAYMENT = {
  label: 'Mensualité',
  suffix: '€',
  tooltip: 'Le montant que vous devrez rembourser chaque mois à la banque.',
}

export const RATE = {
  label: 'Taux estimé',
  roundTo: 0.01,
  suffix: '%',
  tooltip: 'Le taux d’intérêt auquel vous pouvez prétendre selon les informations renseignées.',
}

export const NEW_RATE = {
  ...RATE,
  label: 'Nouveau taux estimé',
}

export const RENEGOTIATION = {
  label: 'Nouvelle mensualité',
  suffix: '€ / mois',
  tooltip: 'Le nouveau montant que vous devrez rembourser à la banque pour la même durée.',
}

export const SAVINGS = {
  label: 'Économies réalisées',
  suffix: '€',
  tooltip: 'Le montant estimé que vous économiserez suite à l’opération de rachat.',
}
